import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigurationSettingsService } from './configuration-settings.service';

export interface RecordListPreferences {
  viewMode: 'list' | 'card' | 'kanban';
  perPage: number;
  sidebarWidth?: number;
}

export interface RecordListPreferencesResponse {
  configurationId: string;
  preferences: RecordListPreferences | null;
}

@Injectable({ providedIn: 'root' })
export class RecordListPreferencesService {
  constructor(private readonly configuration: ConfigurationSettingsService) {}

  get(configurationId: string): Observable<RecordListPreferencesResponse> {
    return this.configuration.recordListPreferences<RecordListPreferencesResponse>(configurationId);
  }

  save(configurationId: string, preferences: RecordListPreferences): Observable<RecordListPreferencesResponse> {
    return this.configuration.saveRecordListPreferences<RecordListPreferencesResponse>(configurationId, preferences);
  }
}
